module.exports = __webpack_public_path__ + "img/materials.53f35e91.svg";